import {EventSubscriber, HasEventName} from "@/modules/base/events";
import {inject, injectable} from "inversify";
import {NegotiatorFactory} from "@/modules/staff/services/factories/NegotiatorFactory";
import {Player, Team} from "@/modules/team/entity";
import {AfterCreateGameEvent} from "@/modules/base/events/AfterCreateGameEvent";
import {AfterSeasonEvaluationEvent} from "@/modules/season/events/AfterSeasonEvaluationEvent";

@injectable()
export class GameCreationEventSubscriber implements EventSubscriber {
  constructor(
    @inject(NegotiatorFactory) private negotiatorFactory: NegotiatorFactory,
  ) {
  }

  priority(): number {
    return 0;
  }

  init(): { event: HasEventName; callback: (event: any) => void }[] {
    return [
      {event: AfterCreateGameEvent, callback: this.onAfterCreateGameEvent},
      {event: AfterCreateGameEvent, callback: this.revealPlayersOnTeam},
      {event: AfterSeasonEvaluationEvent, callback: this.revealPlayersOnTeam},
    ];
  }

  async onAfterCreateGameEvent(event: AfterCreateGameEvent): Promise<void> {
    const team = await Team.current();
    await times(1).forEachAsync(async () => {
      const negotiator = await this.negotiatorFactory.generate();
      negotiator.team = team;
      await negotiator.save();
    });
  }

  async revealPlayersOnTeam(event: AfterCreateGameEvent): Promise<void> {
    await (
      await Player
        .createQueryBuilder('player')
        .leftJoin('player.team', 'team')
        .where('team.user = true')
        .getMany()
    ).forEachAsync(async (player: Player) => {
      player.revelation = 100;
      await player.save();
    });
  }
}